import React from "react";
import { DatePicker } from "antd";
import { ReactComponent as CalendarIcon } from "asset/calendar_icon.svg";
import style from "css/admin/component.module.css";

function SearchDatePicker({ width, style: styleProp, ...props }) {
    const mergedStyle =
        width != null
            ? { width, ...(styleProp || {}) }
            : styleProp;
    return (
        <div className={style.search_datepicker}>
            <DatePicker
                format="YYYY-MM-DD"
                allowClear
                placeholder="YYYY-MM-DD"
                suffixIcon={<CalendarIcon className={style.datePicker_icon} />}
                style={mergedStyle}
                {...props}
            />
        </div>
    );
}

export default SearchDatePicker;

